import { render } from "./SMScHistory.vue?vue&type=template&id=24d2b267"
import script from "./SMScHistory.vue?vue&type=script&lang=js"
export * from "./SMScHistory.vue?vue&type=script&lang=js"

import "./SMScHistory.vue?vue&type=style&index=0&id=24d2b267&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__